import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const darkBackgroundState = atom({
  key: "darkBackgroundState",
  default: false,
  effects_UNSTABLE: [ocPersistAtom],
});
